import React from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'

const TagListItem = ({tag,removeTagHandler}) => {
    return (
        <div 
            className='flex cursor-default justify-between  gap-1 bg-[#8D82B6] mx-1 px-2 py-1 text-white rounded-lg'>
            <span>{tag}</span>
            <AiFillCloseCircle className='text-[#ebe8fa] cursor-pointer' onClick={()=>removeTagHandler(tag)}/>
        </div>
    )
}

export default TagListItem
